function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.292 5.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M108.021 143.806h-3.704a.796.796 0 0 0-.794.794v3.704c0 .436.357.794.794.794h3.704a.796.796 0 0 0 .794-.794V144.6a.796.796 0 0 0-.794-.794m-3.175 4.233a.265.265 0 0 1-.53 0v-3.175a.265.265 0 0 1 .53 0zm1.058 0c0 .146-.119.265-.264.265a.265.265 0 0 1-.265-.265v-1.587a.265.265 0 0 1 .53 0zm1.059 0a.265.265 0 0 1-.53 0v-2.646a.265.265 0 0 1 .53 0zm1.058 0a.265.265 0 0 1-.53 0v-.529c0-.145.12-.265.265-.265s.265.12.265.265z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-103.523 -143.806)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.3bf5ca00eec2b3557284849c451a3390.svg";
export { ForwardRef as ReactComponent };